module.exports = __webpack_public_path__ + "menu_1_pc.d823cae0.png";